import { extensionContainer } from '../../../../../../../common/container/ContainerContext';
import { injectEntity } from '../../../../../../../common/store/base/injectEntity';
import { injectEntityList } from '../../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../../common/store/base/injectPrimitive';
import { UIStore } from '../../../../../../../common/store/base/UIStore';
import { IEntityListStore } from '../../../../../../../common/store/interface/IEntityListStore';
import { IEntityStore } from '../../../../../../../common/store/interface/IEntityStore';
import { IUserProjectRoleModel } from '../../../../../../../service/projectRole/entity/IUserProjectRoleModel';
import { ISpecificationEntityModel } from '../../../../../../../service/specification/entity/ISpecificationEntityModel';
import { ILocalization, ILocalizationToken } from '../../../../../application/language/ILocalization';
import { IContextModel } from '../../../../../service/context/IContextModel';
import { IUnitModel } from '../../../../../service/unit/interface/IUnitModel';
import { generateUUID } from '../../../../../utils/generateUUID';
import { IStepContent } from '../../../../design/stepper/CustomStepper';

const createDefaultUnit = (): IEntityStore<IUnitModel> => {
  const { translate }: ILocalization = extensionContainer.getByToken(ILocalizationToken)

  return injectEntity({
      id: '',
      createDate: undefined,
      isDeleted: false,
      isActive: true,
      isIncluded: false,
      isPublished: false,
      wasPublished: false,
      quiz: {
        isEnabled: true,
        passageTime: '0',
        results: {
          success: {
            title: '',
            subtitle: '',
          },
          neutral: {
            title: '',
            subtitle: '',
          },
          failure: {
            title: '',
            subtitle: '',
          },
        },
        questions: [
          {
            name: '',
            explanation: '',
            type: 'single',
            randomize: true,
            answers: [],
            sortIndex: 1,
            pseudoId: generateUUID(),
            isCodeExample: false,
            codeExample: [],
          },
        ],
      },
      practice: {
        isEnabled: true,
        passageTime: '0',
        results: {
          success: {
            title: '',
            subtitle: '',
          },
          neutral: {
            title: '',
            subtitle: '',
          },
          failure: {
            title: '',
            subtitle: '',
          },
        },
        tasks: [
          {
            name: translate('createUnit.taskOne'),
            explanation: '',
            type: 'review',
            languages: [],
            sortIndex: 1,
            pseudoId: generateUUID(),
          },
        ],
      },
      theory: {
        chapters: [
          {
            title: translate('createUnit.chapterNumber', {number: 1}),
            theoryBlocks: [],
            sortIndex: 0,
            pseudoId: generateUUID(),
          },
        ],
        isEnabled: true,
      },
      finalResult: {
        isEnabled: true,
        results: {
          success: {
            title: translate('passing.resultSuccessTitle'),
            subtitle: translate('passing.resultSuccessSubtitle'),
          },
          neutral: {
            title: translate('passing.resultOkTitle'),
            subtitle: translate('passing.resultOkSubtitle'),
          },
          failure: {
            title: translate('passing.resultFailureTitle'),
            subtitle: translate('passing.resultFailureSubtitle'),
          },
        },
      },
      settings: {
        contextId: '',
        characteristicsId: '',
        characteristicsIds: [],
        teamRolesIds: [],
        titleHeading:  translate('createUnit.newUnit'),
        titleLead: '',
        description: '',
        preview: { data: '', name: '', originalName: '', type: 'image' },
      },
      lastUpdateDate: undefined,
      score: 0,
    })
}

export class UnitUi extends UIStore {
  constructor(
    public isLoading = injectPrimitive<boolean>(false),
    public isEmpty = injectPrimitive<boolean>(false),
    public stepsTitles = injectEntityList<string>([]),
    public stepsCodes = injectEntityList<string>([]),
    public stepContent = injectEntityList<IStepContent>([]),
    public contexts: IEntityListStore<IContextModel> = injectEntityList([]),
    public characteristic: IEntityListStore<ISpecificationEntityModel> = injectEntityList([]),
    public teamRoles: IEntityListStore<IUserProjectRoleModel> = injectEntityList([]),
    public validSteps: IEntityStore<Record<string, boolean>> = injectEntity({
      settings: false,
      theory: true,
      quiz: true,
      practice: true,
    }),
    public unit: IEntityStore<IUnitModel> = createDefaultUnit(),
  ) {
    super();
  }

  startLoading(): void {
    this.isEmpty.setValue(false);
    this.isLoading.setValue(true);
  }
  endLoading(): void {
    this.isLoading.setValue(false);
  }
}
